import React from "react";
import {withStyles, Grid} from "@material-ui/core";
import {
  convertToUSDollars,
  getPaymentTypeLabelFromCode,
} from "./util";
import FormSectionHeader from "./../common/FormSectionHeader";

const styles = (theme) => ({
  flexRow: {
    display: "flex",
    direction: "column",
    "&>div": {
      flex: 1,
      width: "100%",
    },
  },
  label: {
    display: "flex",
    fontWeight: 400,
    fontSize: theme.headerTextFontSize,
    lineHeight: "19px",
    color: theme.iconColor,
  },
  valueFlexEnd: {
    display: "flex",
    fontWeight: 600,
    fontSize: theme.headerTextFontSize,
    lineHeight: "19px",
    color: theme.dispatchPanelLabelValueColor,
    justifyContent: "flex-end",
  },
  valueFlexStart: {
    display: "flex",
    fontWeight: 600,
    fontSize: theme.headerTextFontSize,
    lineHeight: "19px",
    color: theme.dispatchPanelLabelValueColor,
    justifyContent: "space-start",
  },
  divider: {
    borderTop: `1px solid ${theme.dividerColor}`,
    marginTop: 15,
    marginBottom: 0,
  },
  container: {
    minWidth: "20%",
    justifyContent: "space-between",
  }
});

const PaymentDetailsInfo = withStyles(styles)(
  ({classes, label, value, paymentType, checkNumber, amountCollected}) => (
    <Grid item container xs={12} spacing={8} className={classes.container}>
      <Grid item xs={6} className={classes.label}>
        {label}
      </Grid>
      <Grid item xs={6} className={classes.valueFlexEnd}>
        {convertToUSDollars(value)}
      </Grid>
      <Grid item xs={4}>
        <Grid item className={classes.label}>
          Payment Type
        </Grid>
        <Grid item className={classes.valueFlexStart}>
          {paymentType}
        </Grid>
      </Grid>
      {checkNumber &&
        <Grid item>
          <Grid item className={classes.label}>
            Check #
          </Grid>
          <Grid item className={classes.valueFlexStart}>
            {checkNumber}
          </Grid>
        </Grid>
      }
      <Grid item>
        <Grid item className={classes.label}>
          Amount Collected
        </Grid>
        <Grid item className={classes.valueFlexEnd}>
          {convertToUSDollars(amountCollected)}
        </Grid>
      </Grid>
    </Grid>
))


const PaymentDetailsSummary = ({classes, data}) => {
  const {
    freightAmount,
    codAmount,
    freightPaymentType,
    freightCheckNumber,
    freightAmountCollected,
    codPaymentType,
    codCheckNumber,
    codAmountCollected,
  } = data;
  const pendingFreightCharge = Number(freightAmount);
  const pendingCodCharge = Number(codAmount);
  return (
    <Grid container spacing={8}>
      <Grid item xs={12} className={classes.divider}></Grid>
      <Grid item xs={12}><FormSectionHeader label="PAYMENT DETAILS" /></Grid>
      {pendingFreightCharge > 0 &&
        <PaymentDetailsInfo
          label="Freight Charge"
          value={freightAmount}
          paymentType= {getPaymentTypeLabelFromCode({paymentType: "freightPaymentType", paymentTypeCode: freightPaymentType})}
          checkNumber= {freightCheckNumber}
          amountCollected= {freightAmountCollected}
        />
      }
      {pendingCodCharge > 0 &&
        <PaymentDetailsInfo
          label="COD Amount"
          value={codAmount}
          paymentType= {getPaymentTypeLabelFromCode({paymentType: "codPaymentType", paymentTypeCode: codPaymentType})}
          checkNumber= {codCheckNumber}
          amountCollected= {codAmountCollected}
        />
      }
      <Grid item xs={12} className={classes.divider}></Grid>
    </Grid>
  );
};

export default withStyles(styles)(PaymentDetailsSummary);